import React from 'react'
import { useLaunchModalContext } from '../../../../contexts/LaunchModalContext'
import { ProgressPillContainer, ProgressPillUnread, ProgressPillActive, ProgressPillComplete } from './style'

interface CarouselProgressPillProps {
  ariaLabel?: string
  progressIndex: number
  duration: number
}

const CarouselProgressPill: React.VFC<CarouselProgressPillProps> =
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  ({ ariaLabel = '', progressIndex, duration }) => {
    const { activeIndex, isPlaying, dataTaktId, goToSlide } = useLaunchModalContext()

    return (
      <ProgressPillContainer onClick={() => goToSlide(progressIndex)} aria-label={ariaLabel} data-takt-id={`${dataTaktId}_progress-pill-${progressIndex}`}>
        {!isPlaying ? (
          progressIndex > activeIndex ? (
            <ProgressPillUnread />
          ) : (
            <ProgressPillComplete />
          )
        ) : progressIndex == activeIndex ? (
          <ProgressPillActive duration={duration} />
        ) : progressIndex > activeIndex ? (
          <ProgressPillUnread />
        ) : (
          <ProgressPillComplete />
        )}
      </ProgressPillContainer>
    )
  }

export default CarouselProgressPill
